import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-star",
  "use": "svg_i-star-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 14\" id=\"svg_i-star\"><path d=\"m8 .69 2.06 4.125 4.606.665-3.333 3.209.787 4.533L8 11.081l-4.12 2.141.786-4.533L1.333 5.48l4.607-.665L8 .69Z\" stroke=\"#6CC286\" stroke-width=\"1.333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol